import { render, staticRenderFns } from "./MfaSetup.vue?vue&type=template&id=42e24a78&scoped=true"
import script from "./MfaSetup.vue?vue&type=script&lang=ts"
export * from "./MfaSetup.vue?vue&type=script&lang=ts"
import style0 from "./MfaSetup.vue?vue&type=style&index=0&id=42e24a78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e24a78",
  null
  
)

export default component.exports